import React from 'react';
import { useTranslation } from 'react-i18next';

import { TypographyProps } from './types';

export const Typography: React.FC<TypographyProps> = ({
  variant = 'p',
  weight = 400,
  textKey,
  text = '',
  className = '',
}) => {
  const { t } = useTranslation();
  const fontWeight = {
    400: 'font-normal',
    500: 'font-medium',
    600: 'font-semibold',
    700: 'font-bold',
  };

  const Component = variant;

  return (
    <Component
      className={`${fontWeight[weight]} ${className} ${variant === 'a' ? 'text-[#059986]' : ''}`}
    >
      {textKey ? t(textKey) : text}
    </Component>
  );
};
